import React, { Component } from 'react';

class Notices extends Component {
    componentDidMount(){
        window.scroll(0,0)
    }
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="header">
                            <p style={{ fontFamily: "Calibri", fontSize: "20px", fontWeight: "bold" }}>NOTICE OF CHANGE</p>
                            <p style={{ fontFamily: "Calibri", fontSize: "20px", fontWeight: "bold" }}>IMPORTANT INFORMATION REGARDING GM CABS RELOADABLE VISA PREPAID PRODUCT </p>

                        </div>
                        <div className="col-sm-12" style={{ fontSize: "11px" }}>
                            <p style={{ fontFamily: "Calibri", fontSize: "14px", }}>From 5 October 2021, new requirements apply to how your complaints are handled in relation to the GM Cabs Reloadable Visa Prepaid Card <b>(the Product)</b>.</p>
                            <p style={{ fontFamily: "Calibri", fontSize: "14px", }}>The below changes to the matters as described in the Product Disclosure Statement for the Product will become effective on 4 November 2021. </p>

                        </div>
                        <div className="col-sm-12" >
                            <p style={{ fontFamily: "Calibri", fontSize: "16px", fontWeight: "bold" }}><b>Transaction Disputes</b></p>
                            <span style={{ fontFamily: "Calibri", fontSize: "14px", }}>
                                <p> For disputed transactions (including unauthorised transactions), the following will apply. </p>
                                <p>For disputed transactions you should contact Cardholder Support immediately by calling 1800
                                    914 332 or by the Contact Us tab on the website printed on the back of your card or the Cardholder App. Visa Scheme Rules impose time limits after the expiry of which our ability to dispute a transaction on your behalf may be lost.  We may not be responsible for any loss to you where it can be shown that you have unreasonably delayed notifying us.
                                </p>

                            </span>
                        </div>
                        <div className="col-sm-12" style={{}}>
                            <p style={{ fontFamily: "Calibri", fontSize: "16px", fontWeight: "bold" }}><b>Queries and Complaints  </b></p>
                            <p style={{ fontFamily: "Calibri", fontSize: "14px" }}>We will handle complaints in accordance with the following process. </p>
                            <p style={{ fontFamily: "Calibri", fontSize: "14px", }}>
                                If you have a complaint about the Product or our services,
                                please contact Cardholder Support by calling 1800 914 332 or by the Contact Us tab on the website printed on the back of your card or the Cardholder App.
                                We will acknowledge your complaint promptly, either verbally or in writing, and do our best to resolve it straight away.
                                If we can’t resolve your complaint within 5 business days, we will provide you with a written response providing the final outcome no later than 30 days.
                                We aim to resolve all complaints within 21 days. However in some cases it may take up to 30 days.
                                Your complaint may take a little longer to assess if we need more information or if your complaint is complex.
                                In all cases, we’ll keep you updated on the progress.
                                You can ask for information about how we manage complaints in alternative formats and languages upon request by calling 1800 914 332.
                                If you have a hearing or speech impairment, you can access additional support through the National Relay Service on 1300 555 727.
                            </p>
                            <p style={{ fontFamily: "Calibri", fontSize: "14px", }}>
                                If you are not satisfied with our response, you may lodge a complaint with the Australian Financial Complaints Authority (AFCA).  AFCA provides free and independent financial services complaint resolution and can be contacted on
                                Website:
                                <a style={{ fontSize: "14px", color: "blue", fontWeight: "bold" }} href="https://www.afca.org.au/" target="_blank"> <u>www.afca.org.au</u> </a>
                                Email:
                                <a style={{ fontSize: "14px", color: "blue", fontWeight: "bold" }} href="info@afca.org.au"> <u>info@afca.org.au</u> </a>
                                Phone: 1800 931 678 (free call)
                                Mail: GPO Box 3, Melbourne VIC 3001.
                                Time limits may apply to complain to AFCA and so you should act promptly or otherwise consult the AFCA website to find out if or when the time limit relevant to your circumstances expires.

                            </p>
                            <p style={{ fontFamily: "Calibri", fontSize: "14px", }}>
                                To contact the Issuer, Heritage Bank Limited, about your complaint:
                            </p>
                            <p style={{ fontFamily: "Calibri", fontSize: "14px", }}>
                                Phone: Australia: 1800 797 799 (free call) Overseas: +61 7 4690 9000
                            </p>
                            <p style={{ fontFamily: "Calibri", fontSize: "14px", }}>
                                Website:
                                <a style={{ fontSize: "14px", color: "blue", fontWeight: "bold" }} href="https://www.heritage.com.au/" target="_blank"> <u>www.heritage.com.au</u> </a>
                            </p>
                            <p style={{ fontFamily: "Calibri", fontSize: "14px", }}>
                                Email: <a style={{ fontSize: "14px", color: "blue", fontWeight: "bold" }} href="complaints@heritage.com.au"> <u>complaints@heritage.com.au</u> </a>
                            </p>
                            <p style={{ fontFamily: "Calibri", fontSize: "14px", }}>
                                Mail: Heritage Bank Limited,  Reply Paid 190, Toowoomba QLD 4350
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Notices;


// WEBPACK FOOTER //
// ./src/components/Notices/notices.jsx